import React, { useEffect, useState } from "react";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config from "../../Config";
import axios from "axios";

import { useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import Select from "react-select";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import Loading from "react-loading";
import {
  InputGroup,
  FieldWrapper,
  Label,
  CombineInputGroup,
  CombineInputGridGroup,
  SubmitBtn,
} from "../../Components/Styles/InputStyles";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useTranslation } from "react-i18next";
// import Loading from "../../Components/Loading";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
const AddProcessedMaterial = () => {
  const [cropName, setCropName] = useState("");
  const user = useSelector((state) => state.UserReducer.user);
  const cropNames =
    user?.cropName?.map((crop) => ({
      value: crop.id,
      label: crop.cropName,
    })) || [];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { companyId } = useParams();
  const [isDataFetched, setIsDataFetched] = useState(false);
  const GetProduct = async () =>
    await axios.get(`${Config.apiUrl}/getProduct/${companyId}`, {
      headers: {
        Authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

  const {
    isLoading: InitialLoading,
    data,
    error,
    refetch,
    isRefetching,
  } = useQuery("get-farmer", GetProduct, {
    enabled: !isDataFetched,
  });
  console.log(data);

  useEffect(() => {
    if (data?.data && !isDataFetched) {
      setIsDataFetched(true);
    }
  }, [isDataFetched, data]);

  //------- Add Single Entry -------
  const AddFarmerPostFunction = async (values) => {
    const body = new FormData();

    body.append("productId", values.productId);
    if (user.companyName == "Kimolo Super Rice Ltd") {
      body.append("gradec", values.gradec);
      body.append("graded", values.graded);

      body.append("balancec", values.balancec);
      body.append("balanced", values.balanced);

      body.append("issuegradec", values.issuegradec);
      body.append("issuegraded", values.issuegraded);
    }
    body.append("gradea", values.gradea);
    body.append("gradeb", values.gradeb);
    body.append("issuegradeb", values.issuegradeb);
    body.append("issuegradea", values.issuegradea);
    body.append("balance", values.balance);
    body.append("balanceb", values.balanceb);

    body.append("companyId", user?.companyId);
    body.append("date", values.date);
    body.append("dispatchDate", values.dispatchDate);

    return await axios.post(`${Config.apiUrl}/add-product`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddUserSuccess = (data) => {
    console.log(data);
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      navigate("/processes-product");
    } else {
      toast.error(data?.data?.msg);
    }
  };

  const onAddUserError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: AddSubAgentLoading, mutate: postFarmerUser } = useMutation(
    AddFarmerPostFunction,
    {
      onSuccess: onAddUserSuccess,
      onError: onAddUserError,
    }
  );

  const SubmitHandler = (values) => {
    postFarmerUser({ ...values });
  };
  const ProductList = data?.data?.data?.map((item) => ({
    value: item.productId,
    label: item.productName,
  }));
  const InitialValue = {
    gradea: "",
    gradeb: "",
    gradec: "",
    graded: "",

    balance: "",
    balanceb: "",
    balancec: "",
    balanced: "",

    issuegradea: "",
    issuegradeb: "",
    issuegradec: "",
    issuegraded: "",

    date: "",
    dispatchDate: "",
    id: "",
    productId: "",
    productName: "",
  };
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-center items-center">
            <div>
              <Title>Add Processed Product</Title>
              <Underline />
            </div>
          </div>
          <TextWrapper>
            <Formik initialValues={InitialValue} onSubmit={SubmitHandler}>
              <>
                <Form>
                  <Wrapper>
                    <CombineInputGroup>
                      <InputGroup>
                        <Label htmlFor="productId">Product Name</Label>
                        <FieldWrapper $select={true}>
                          <Field
                            name="productId"
                            id="productId"
                            autoComplete="off"
                          >
                            {(props) => (
                              <Select
                                className="w-full h-full"
                                required
                                options={ProductList}
                                classNamePrefix="select"
                                onChange={(val) => {
                                  props.form.setFieldValue(
                                    "productId",
                                    val.value
                                  );
                                }}
                              />
                            )}
                          </Field>
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="date">Receiving Date</Label>
                        <FieldWrapper>
                          <Field
                            type="date"
                            name="date"
                            id="date"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="dispatchDate">Dispatch Date</Label>
                        <FieldWrapper>
                          <Field
                            type="date"
                            name="dispatchDate"
                            id="dispatchDate"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                    </CombineInputGroup>
                    <CombineInputGridGroup>
                      <InputGroup>
                        <Label htmlFor="gradea">
                          Quantity Received Grade A(kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            type="number"
                            name="gradea"
                            id="gradea"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="gradeb">
                          Quantity Received Grade B(kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            type="number"
                            name="gradeb"
                            id="gradeb"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                      {user.companyName == "Kimolo Super Rice Ltd" && (
                        <>
                          <InputGroup>
                            <Label htmlFor="gradec">
                              Quantity Received Grade C(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                type="number"
                                name="gradec"
                                id="gradec"
                                autoComplete="off"
                                className="truncate"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>

                          <InputGroup>
                            <Label htmlFor="graded">
                              Quantity Received Grade D(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                type="number"
                                name="graded"
                                id="graded"
                                autoComplete="off"
                                className="truncate"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>
                        </>
                      )}
                    </CombineInputGridGroup>

                    <CombineInputGridGroup>
                      <InputGroup>
                        <Label htmlFor="issuegradea">
                          Quantity Issued Grade A(kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            name="issuegradea"
                            id="issuegradea"
                            autoComplete="off"
                            type="number"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="issuegradeb">
                          Quantity Issued Grade B(kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            name="issuegradeb"
                            id="issuegradeb"
                            autoComplete="off"
                            type="number"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                      {user.companyName == "Kimolo Super Rice Ltd" && (
                        <>
                          <InputGroup>
                            <Label htmlFor="issuegradec">
                              Quantity Issued Grade C(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="issuegradec"
                                id="issuegradec"
                                autoComplete="off"
                                type="number"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="issuegraded">
                              Quantity Issued Grade D(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="issuegraded"
                                id="issuegraded"
                                autoComplete="off"
                                type="number"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>
                        </>
                      )}
                    </CombineInputGridGroup>

                    <CombineInputGridGroup>
                      <InputGroup>
                        <Label htmlFor="balance">
                          Balance Quantity Grade A (kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            type="number"
                            name="balance"
                            id="balance"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="balanceb">
                          Balance Quantity Grade B (kg)
                        </Label>
                        <FieldWrapper>
                          <Field
                            type="number"
                            name="balanceb"
                            id="balanceb"
                            autoComplete="off"
                            className="truncate"
                            required
                          />
                        </FieldWrapper>
                      </InputGroup>
                      {user.companyName == "Kimolo Super Rice Ltd" && (
                        <>
                          <InputGroup>
                            <Label htmlFor="balancec">
                              Balance Quantity Grade C(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                type="number"
                                name="balancec"
                                id="balancec"
                                autoComplete="off"
                                className="truncate"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>

                          <InputGroup>
                            <Label htmlFor="balanced">
                              Balance Quantity Grade D(kg)
                            </Label>
                            <FieldWrapper>
                              <Field
                                type="number"
                                name="balanced"
                                id="balanced"
                                autoComplete="off"
                                className="truncate"
                                required
                              />
                            </FieldWrapper>
                          </InputGroup>
                        </>
                      )}
                    </CombineInputGridGroup>
                  </Wrapper>
                  <BtnWrapper>
                    <SubmitBtn type="submit" disabled={AddSubAgentLoading}>
                      {" "}
                      {AddSubAgentLoading ? (
                        <Loading
                          color="white"
                          width={20}
                          height={20}
                          noPadding={true}
                        />
                      ) : (
                        t("Add")
                      )}
                    </SubmitBtn>
                  </BtnWrapper>
                </Form>
              </>
            </Formik>
          </TextWrapper>
        </BoxContainer>
      </Bg>
    </>
  );
};

const TextWrapper = tw.div`h-full w-full flex justify-center`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const UpdateBtn = tw.button`
text-sm  w-32  md:w-60 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-custom-green hover:bg-green-700 text-white rounded-md shadow-md md:mx-44`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;
const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;

export default AddProcessedMaterial;
